export default __webpack_public_path__ + "static/media/466.11b342f4.png";